<template>
    <entity-reader entity="lammie" :id="id" :use-sharing="false" api-name="lammieRequests">
        <template v-slot:[`reader`]="{ doc }">
            <label-value name="Name" :value="doc.name" />
            <v-row>
                <v-col cols="12" sm="2">
                    <span class="font-weight-medium">Plot</span>
                </v-col>
                <v-col cols="12" sm="10">
                    <router-link :to="{ name: 'readPlot', params: { id: doc.plotKeyId } }" :title="doc.plotName">
                        {{ doc.plotName }}
                    </router-link>
                </v-col>
            </v-row>
            <label-value name="Event Needed" :value="getEventName(doc.eventId)" />
            <label-value name="Year Required" :value="doc.yearRequired" />
            <label-value name="Duration" :value="doc.requiredDuration" />
            <label-value name="Reprint" :value="doc.isReprint" />
            <label-value name="Phys Rep" :value="doc.physRep" />
            <label-value name="Purpose" :value="doc.intendedPurpose" />
            <label-value name="Powers" :value="doc.powers" />
            <label-value name="Notes" :value="doc.notes" />
            <label-value name="Lore Codes" :value="doc.loreCodes" />
        </template>
    </entity-reader>
</template>
<script>
import { mapGetters } from 'vuex'
import EntityReader from '../../components/EntityRead'
import LabelValueRender from '../../components/LabelValueRender'
export default {
    name: 'LammieRequestReader',
    components: {
        'entity-reader': EntityReader,
        'label-value': LabelValueRender,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
    },
    computed: {
        ...mapGetters(['events']),
    },
    methods: {
        getEventName(eventId) {
            if (!eventId || !this.events || this.events.length === 0) return ''
            let event = this.events.find(x => x.id === eventId)
            return event.name || ''
        },
    },
}
</script>
